import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, resolveDirective as _resolveDirective, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72c3eeb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "model-selector__title" }
const _hoisted_2 = { class: "model-selector__sub-title" }
const _hoisted_3 = { class: "dt-card__body" }
const _hoisted_4 = { class: "list-wrapper pool" }
const _hoisted_5 = {
  key: 0,
  class: "dt-list"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "dt-list__title" }
const _hoisted_8 = {
  class: "icon icon--color icon--small",
  viewBox: "0 0 24 24"
}
const _hoisted_9 = ["d"]
const _hoisted_10 = {
  key: 0,
  class: "no-location-search-results"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 1,
  class: "empty-message"
}
const _hoisted_13 = { class: "divider" }
const _hoisted_14 = {
  class: "icon",
  viewBox: "0 0 24 24"
}
const _hoisted_15 = ["d"]
const _hoisted_16 = { class: "list-wrapper active" }
const _hoisted_17 = {
  key: 0,
  class: "dt-list active"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 0,
  class: "no-location-search-results"
}
const _hoisted_20 = ["src"]
const _hoisted_21 = {
  key: 1,
  class: "no-location-search-results"
}
const _hoisted_22 = {
  key: 0,
  class: "modal-callout__container"
}
const _hoisted_23 = {
  key: 0,
  class: "callout callout--no-max callout--warning"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "This signage list is used in rooms that you do not have access to.", -1))
const _hoisted_25 = {
  key: 1,
  class: "callout callout--no-max callout--danger mt-1"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "You will lose access to this signage list if you remove it from all of your rooms. Try hiding the list instead.", -1))
const _hoisted_27 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_selection = _resolveComponent("selection")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.isVisible,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isVisible) = $event)),
    "custom-class": "modal-selector-dialog",
    "before-close": _ctx.handleClose
  }, {
    title: _withCtx(() => [
      _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.title), 1),
      _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.subTitle), 1)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_27, [
        _createVNode(_component_el_button, { onClick: _ctx.onCancel }, {
          default: _withCtx(() => [
            _createTextVNode("Cancel")
          ]),
          _: 1
        }, 8, ["onClick"]),
        (!_ctx.hideSaveButton)
          ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              onClick: _ctx.onSave
            }, {
              default: _withCtx(() => [
                _createTextVNode("Save")
              ]),
              _: 1
            }, 8, ["onClick"])), [
              [_directive_loading, _ctx.loading]
            ])
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_selection, null, {
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("article", _hoisted_4, [
              _createVNode(_component_el_input, {
                placeholder: _ctx.searchPlaceholder,
                modelValue: _ctx.selectionPoolSearch,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectionPoolSearch) = $event))
              }, null, 8, ["placeholder", "modelValue"]),
              (_ctx.selectionPool)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectionPool.filter(x=>x.name.toLowerCase().includes(_ctx.selectionPoolSearch.toLowerCase())), (item) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: item.id,
                        class: _normalizeClass([{ added: item.selected, disabled: item.disabled }, "dt-list__item"]),
                        onClick: ($event: any) => (_ctx.selectionPoolClick(item))
                      }, [
                        _createElementVNode("span", _hoisted_7, _toDisplayString(item.name), 1),
                        _withDirectives((_openBlock(), _createElementBlock("svg", _hoisted_8, [
                          _createElementVNode("path", { d: _ctx.mdiCheckBold }, null, 8, _hoisted_9)
                        ], 512)), [
                          [_vShow, item.selected]
                        ])
                      ], 10, _hoisted_6))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_ctx.selectionPool)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("img", {
                            src: require('../assets/images/Whats-Mirroring.png')
                          }, null, 8, _hoisted_11),
                          _createElementVNode("span", null, "No " + _toDisplayString(_ctx.modelTypeName) + " match search", 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createElementVNode("span", null, "Uh oh. It doesn't look like you've created any " + _toDisplayString(_ctx.modelTypeName) + "!!.", 1)
                        ]))
                  ], 64))
            ]),
            _createElementVNode("span", _hoisted_13, [
              (_openBlock(), _createElementBlock("svg", _hoisted_14, [
                _createElementVNode("path", { d: _ctx.mdiSwapHorizontal }, null, 8, _hoisted_15)
              ]))
            ]),
            _createElementVNode("article", _hoisted_16, [
              _createVNode(_component_el_input, {
                placeholder: _ctx.searchPlaceholder,
                modelValue: _ctx.selectedPoolSearch,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedPoolSearch) = $event))
              }, null, 8, ["placeholder", "modelValue"]),
              (_ctx.selectionPool)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_17, [
                    _createVNode(_TransitionGroup, { name: "swap-list" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectionPool.filter(x=>x.selected && x.id != '*').filter(x=>x.name.toLowerCase().includes(_ctx.selectedPoolSearch.toLowerCase())), (item) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: item.id,
                            onClick: ($event: any) => (_ctx.selectedPoolClick(item)),
                            class: _normalizeClass(["dt-list__item", { disabled: item.disabled }])
                          }, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["dt-list__title", { disabled: item.disabled }])
                            }, _toDisplayString(item.name), 3)
                          ], 10, _hoisted_18))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_ctx.selectionPool)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createElementVNode("img", {
                            src: require('../assets/images/Whats-Mirroring.png')
                          }, null, 8, _hoisted_20),
                          _createElementVNode("span", null, "No " + _toDisplayString(_ctx.modelTypeName) + " match search", 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _createElementVNode("span", null, "No " + _toDisplayString(_ctx.modelTypeName) + "!", 1),
                          _createElementVNode("span", null, "Add " + _toDisplayString(_ctx.modelTypeName) + "s by selecting from the pool to the left", 1)
                        ]))
                  ], 64))
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ]),
          (_ctx.shouldShowRemoveRoomMessage || _ctx.showNoAccessRoomMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                (_ctx.showNoAccessRoomMessage)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createVNode(_component_Icon, {
                        class: "icon icon--x-large icon--warning",
                        icon: _ctx.mdiAlertCircle
                      }, null, 8, ["icon"]),
                      _hoisted_24
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.shouldShowRemoveRoomMessage)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createVNode(_component_Icon, {
                        class: "icon icon--x-large icon--danger",
                        icon: _ctx.mdiAlertCircle
                      }, null, 8, ["icon"]),
                      _hoisted_26
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "before-close"]))
}